import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LoadingPage from '../components/LoadingPage';
import { initializeKeycloak, resolveUser } from '../user/userActions';

const AuthProvider = ({ children, dispatch }) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            try {
                // On first run this either resolves (already authenticated) or
                // calls keycloak.login() which redirects the page — the promise
                // never resolves and the post-redirect page load runs this again.
                await dispatch(initializeKeycloak());
                await dispatch(resolveUser());
                // eslint-disable-next-line no-unused-vars
            } catch (err) {
                // initializeKeycloak / resolveUser both dispatch authenticationFailed
                // on failure; SessionTrackerView reacts to that prop and triggers
                // logout. We still flip ready so the app surfaces that UI instead
                // of staying on a blank LoadingPage.
            } finally {
                if (!cancelled) setReady(true);
            }
        };
        run();
        return () => {
            cancelled = true;
        };
    }, [dispatch]);

    if (!ready) return <LoadingPage />;
    return children;
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default connect()(AuthProvider);
